import { React, Fragment, useState } from "react";
import Contactbanner from "../../assets/images/blog-img3.jpg";
import { FaArrowRight, FaSearch } from "react-icons/fa";
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import BlogCards from "../Blogs/BlogCards";
import blog1 from '../../assets/images/skilled-entrepreneurs-viewing-their-digital-presence.avif';
import blog2 from '../../assets/images/blog-img2.jpg';
import blog3 from '../../assets/images/blog-img3.jpg';
import blog4 from '../../assets/images/blog-img4.jpg';
import blogDes1 from '../../assets/images/blog-des-1.jpg';
import blogDes2 from '../../assets/images/blog-des-2.jpg';
import blogDes3 from '../../assets/images/blog-des-3.jpg';

function BlogDescriptionPage() {


  const blogData = [
    {
      image: blog1,
      title: "Crafting Seamless Web and Mobile Experiences",
      desc: "Discover how modern apps are built to work flawlessly across all platforms.",
      date: "January 15, 2025",
      time: "3min"
    },
    {
      image: blog2,
      title: "Transforming Ideas into Scalable Digital Solutions",
      desc: "We turn your concepts into enterprise-grade applications that grow with your business.",
      date: "February 5, 2025",
      time: "4min"
    },
    {
      image: blog3,
      title: "Driving Innovation in Mobile & Web Development",
      desc: "Explore the cutting-edge tools that are changing the digital landscape.",
      date: "March 12, 2025",
      time: "5min"
    },
    {
      image: blog4,
      title: "Revolutionizing E-commerce Through Custom Platforms",
      desc: "Create personalized shopping experiences with our tailored e-commerce solutions.",
      date: "March 28, 2025",
      time: "2min"
    },
    {
      image: blog2,
      title: "Boosting Business with Cloud-Powered Apps",
      desc: "How cloud technology can scale your business operations efficiently.",
      date: "April 8, 2025",
      time: "4min"
    },
    {
      image: blog3,
      title: "Design-Driven Development for Maximum Impact",
      desc: "Merging UI/UX design with solid development for powerful user engagement.",
      date: "April 20, 2025",
      time: "3min"
    },
    {
      image: blog1,
      title: "Why Mobile-First Strategy Matters in 2025",
      desc: "Understanding the importance of prioritizing mobile in your tech roadmap.",
      date: "May 2, 2025",
      time: "3min"
    },
    {
      image: blog4,
      title: "The Future of IoT and Smart Applications",
      desc: "Take a look into how IoT is transforming daily life and industries.",
      date: "May 19, 2025",
      time: "5min"
    },
    {
      image: blog3,
      title: "Agile Development: Benefits for Fast-Growing Startups",
      desc: "How startups are leveraging agile methodologies for rapid product evolution.",
      date: "June 1, 2025",
      time: "2min"
    },
    {
      image: blog1,
      title: "Top UI/UX Trends You Can’t Ignore This Year",
      desc: "From neomorphism to minimalist design — stay ahead of the design curve.",
      date: "June 10, 2025",
      time: "4min"
    }
  ];
  
  return (
    <Fragment>
      <div
        className="relative w-full bg-gradient-to-br from-[#6D1349] to-[#DF73FF]  h-[30rem] md:h-[44rem]   lg:h-[35rem] bg-top bg-cover bg-no-repeat"
        style={{ backgroundImage: `url(${Contactbanner})` }}
      >
        <div className="absolute inset-0 bg-gradient-to-br from-[#6D1349]/70 to-[#DF73FF]/70"></div>

        {/* Content Section */}
        <div className="max-w-screen-2xl mx-auto  flex flex-col justify-center px-10 md:px-48  text-white relative md:pt-14  space-y-6 h-full">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-3xl font-bold ">
            Novermber 2, 2025  
          </h1>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold ">
          Crafting Seamless Web and Mobile Experiences  
          </h1>

          <div className='py-10'>
            <div className="text-white uppercase text-lg">Ellem TempLetion</div>
            <div className="text-white text-lg italic">Junior Copywriter</div>
          </div>
        </div>
      </div>
    <div className='bg-gray-50'>

      <section className="max-w-full sm:max-w-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl  2xl:max-w-screen2xl mx-auto py-20 px-4  ">
        
      <p className="text-lg text-[#333333] ">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>

      <div className="space-y-5">
      <h1 className='text-3xl mt-10 capitalize text-[#333333]'>5. Lorem ipsum dolor sit amet consectetur </h1>
     <p className="text-lg text-[#333333] ">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <div className='w-[60%] mx-auto'>
      <img src={blogDes1} alt=""  className=' w-full'/>
     </div>
      </div>
      <div className="space-y-5">
      <h1 className='text-3xl mt-10 capitalize text-[#333333]'>2. Lorem ipsum dolor sit amet consectetur </h1>
     <p className="text-lg text-[#333333] ">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <div className='w-[60%] mx-auto'>
      <img src={blogDes2} alt=""  className=' w-full'/>
     </div>
     
      </div>
      <div className="space-y-5">
      <h1 className='text-3xl mt-10 capitalize text-[#333333]'>3. Lorem ipsum dolor sit amet consectetur </h1>
     <p className="text-lg text-[#333333] ">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
      </div>
      <div className="space-y-5">
      <h1 className='text-3xl mt-10 capitalize text-[#333333]'>4. Lorem ipsum dolor sit amet consectetur </h1>
     <p className="text-lg text-[#333333] ">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <p className="text-lg  text-[#333333]">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Excepturi reprehenderit omnis, doloremque quaerat quasi esse quod iusto quo corrupti nisi sunt voluptatibus, delectus dolorem? Aperiam beatae, cum eum nam est corrupti ea aut provident ullam ducimus repellat ab iste numquam, similique consectetur accusamus laboriosam optio nobis nostrum quia ipsum. Perferendis ipsum nihil omnis illum ea veritatis natus commodi 
     </p>
     <div className='w-[60%] mx-auto'>
      <img src={blogDes3} alt=""  className=' w-full'/>
     </div>
      </div>
 
      </section>
      <section className="max-w-full sm:max-w-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl  2xl:max-w-screen2xl mx-auto py-20 px-4  ">
        <h1 className="text-5xl my-20">You might also like</h1>

  <div className='grid grid-cols-1 md:grid-cols-3 gap-x-20 gap-y-10  '>
        {blogData.slice(0,3).map((blog, index) => (
          <div key={index} className='w-[100%] rounded-3xl overflow-hidden shadow-xl'>
            <div>
              <img src={blog.image} alt="" className='object-cover w-full h-full' loading='lazy' />
            </div>
            <div className='px-8 py-5 space-y-5 '>
              <div className='text-[#343434]'>
                <h1 className='text-2xl font-bold'>{blog.title}</h1>
                {/* <p className='text-lg py-3'>{blog.desc}</p> */}
              </div>
              <div className='flex justify-between items-center text-xs border-t border-[#F7F7F7] pt-3 align-bottom'>
                <div className='w-2/6 border-r border-[#CECECE] text-sm capitalize'>
                  {blog.date.split(',')[0]}, <div>{blog.date.split(',')[1]}</div>
                </div>
                <div className='w-5/6 flex justify-between text-[#6D1349] font-bold'>
                  <div className='pl-4'>{blog.time}</div>
                  <div><FaArrowRight className='text-[#6D1349]' /></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
      </section>

      <section className=" py-20 px-4  bg-gradient-tobr from-[#6D1349] to-[#DF73FF] bg-[#DF73FF] ">
<div className='max-w-full sm:max-w-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl  2xl:max-w-screen2xl mx-auto space-y-4'>

      <div className='space-y-4'>
      <h1 className='text-4xl font-semibold text-center  text-white'>Stay Hooked, Stay Updated</h1>
      <p className='text-xl font-semibold text-center  text-gray-100'>
      From builds to breakthroughs, stay in the loop.Get the latest from our tech desk straight to your inbox.
      </p>
     </div>
     <div className='space-y-5'>
        <input type="text" placeholder='Email' className='outline-none border-b w-full py-1 placeholder:text-gray-600 text-white text-7xl bg-transparent' />
     </div>
</div>
     
      </section>
    </div>

    </Fragment>
  );
} 

export default BlogDescriptionPage;
